/**
 * Provides the necessary bindings for `react-router-redux` to use Immutable.js
 */
import { Map } from 'immutable';

const initialState = new Map({
  locationBeforeTransitions: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return new Map({
        locationBeforeTransitions: new Map(action.payload),
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/routing/reducer.js